"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _excluded = ["title", "titleId"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var SvgRedo = function SvgRedo(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0643 25.4285L5.46135 39.6646C5.09994 39.8924 4.7577 40.0001 4.45372 40C3.70836 39.9999 3.19336 39.3523 3.19336 38.2362L3.19336 9.7638C3.19336 8.64765 3.70821 8 4.45372 8C4.7577 8 5.10002 8.10773 5.46135 8.33536L28.0643 22.5715C29.3117 23.3572 29.3117 24.6428 28.0643 25.4285",
    fill: "#61C1FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0643 25.4285L23.4614 39.6646C23.0999 39.8924 22.7577 40.0001 22.4537 40C21.7084 39.9999 21.1934 39.3523 21.1934 38.2362L21.1934 9.7638C21.1934 8.64765 21.7082 8 22.4537 8C22.7577 8 23.1 8.10773 23.4614 8.33536L46.0643 22.5715C47.3117 23.3572 47.3117 24.6428 46.0643 25.4285",
    fill: "#61C1FD"
  }));
};

var _default = SvgRedo;
exports["default"] = _default;